/*
 * Desktop - Pdp - Trustpilot Snippet Above the Fold  --  variant: Stars Plus Customer Quote
 * Moonshot experiment id: m3STdg6MHnF7HV9L9nw2Yh   status in Moonshot on 2026-08-27: RUNNING   started: 2026-08-17
 * Audience: DESKTOP   Target: pdp   (see MGExp.targets in mg-exp-runtime.js)
 * Source: variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_pdp_d_trustpilot_quote
 *
 * CHANGED 2026-10-21 (client email 2026-10-12, item 1): the hand-drawn black stars row is replaced by the official
 * Trustpilot "Micro Combo" TrustBox the client sent (https://trstp.lt/3p0_J1Ypra: "Excellent ★★★★★ 3,452 reviews on
 * Trustpilot", template 5419b6ffb0d04a076446a9af, business unit 617ae3b0bd89f32a251fc62c). The random customer quote
 * underneath is kept, as in the client's mockup. The TrustBox fetches its own score/count, so the old
 * trustbox-data fetch is gone. The bootstrap script (widget.trustpilot.com/bootstrap/v5) is already loaded by
 * layout/theme.liquid; because this element is inserted after page load we call Trustpilot.loadFromElement on it.
 */
MGExp.run('pdp_d_trustpilot_quote', { name: "Desktop - Pdp - Trustpilot Snippet Above the Fold / Stars Plus Customer Quote", platform: 'desktop', target: 'pdp' }, function () {
  !(function () {
    let t = [],
      e = [];
    const o = [
        "Just as advertised. Great price, beautiful product. Very pleased.",
        "Product arrived quickly. In great condition. Will order again in the future.",
        "Product in perfect condition. Fast shipping. Great experience.",
        "10/10 customer service! Thanks for helping me obtain a long-time wishlist piece!",
        "Amazing! Service, products, and quality! I loveeee my purchases!",
        "Wonderful service and products! Have purchased multiple items.",
        "Accurate product description, fast shipping, fair pricing. Would definitely buy from them again!",
        "The product was in great condition as advertised. It looked even better in person. Great deal and fast shipping.",
        "Easy to order, quick delivery, beautiful packaging and wonderful product!",
        "Product was delivered on time, in perfect condition.",
      ],
      s = o[Math.floor(Math.random() * o.length)];

    // Ask the Trustpilot bootstrap to render a TrustBox that was added after it scanned the page.
    function loadTrustBox(widget) {
      let tries = 0;
      (function tick() {
        if (widget.querySelector("iframe")) return; // already rendered (bootstrap loaded after insertion)
        if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === "function") {
          try { window.Trustpilot.loadFromElement(widget, true); } catch (err) {}
          return;
        }
        if (++tries < 80) setTimeout(tick, 250); // keep trying for ~20s while the async bootstrap loads
      })();
    }

    !(async function (i, a, o, s, n, r) {
      let p = {
        multi_target_selectors: t,
        exclude_from_timeout: e,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(i, a, o, s, n, p, r);
    })(
      ["h1.pdp-product-heading"],
      ".msai-tp-quote-applied",
      function (t, e) {
        const [o] = e,
          r = document.createElement("div");
        r.classList.add("msai-tp-quote");
        r.classList.add("msai-tp-quote-applied");
        r.innerHTML =
          '<div class="trustpilot-widget msai-tp-trustbox" data-locale="en-US" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="617ae3b0bd89f32a251fc62c" data-style-height="20px" data-style-width="100%" data-style-alignment="left" data-token="243a9303-a904-480a-8a7b-0441ff58e04f">' +
          '<a href="https://www.trustpilot.com/review/mygemma.com" target="_blank" rel="noopener">Trustpilot</a>' +
          "</div>" +
          `<span class="msai-tp-quote-text">&ldquo;${s}&rdquo;</span>`;
        o.insertAdjacentElement("beforebegin", r);
        loadTrustBox(r.querySelector(".msai-tp-trustbox"));
      },
      ".msai-tp-quote{display:flex;flex-direction:column;gap:8px;margin:8px 0 14px 0;padding:4px 0;font-family:Raleway,sans-serif;line-height:1.2;max-width:560px}.msai-tp-quote .msai-tp-trustbox{min-height:20px;width:420px;max-width:100%}.msai-tp-quote .msai-tp-trustbox > a{font-size:14px;font-weight:600;color:#000000;text-decoration:underline}.msai-tp-quote .msai-tp-quote-text{font-size:13px;font-style:italic;font-weight:500;color:#4B5563;line-height:1.4;max-width:100%}",
    );
  })();
});
